import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Support, TranslateHelper } from '@app/_helpers';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ReplaySubject } from 'rxjs';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { CollapseContentDirective, CollapseItemDirective } from '../../../shared/directives/collapse.directive';

@UntilDestroy()
@Component({
    selector: 'app-select-input',
    templateUrl: './select-input.component.html',
    styleUrls: ['./select-input.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [
        NgIf,
        CdkOverlayOrigin,
        MatIconModule,
        CdkConnectedOverlay,
        NgScrollbarModule,
        NgFor,
        IconComponent,
        CollapseItemDirective,
        CollapseContentDirective,
        NgClass,
        TranslateModule,
    ],
})
export class SelectInputComponent implements OnInit {

    constructor(public translateHelper: TranslateHelper, public translate: TranslateService,
        private cdr: ChangeDetectorRef,

    ) { }

    FilterCtrl: UntypedFormControl = new UntypedFormControl();
    filteredList: ReplaySubject<any> = new ReplaySubject<any>(1);

    @Input() label;
    @Input() borderRadius = '0.25rem';
    @Input() appearance: 'legacy' | 'standard' | 'fill' | 'outline' | 'filter' = 'outline';
    @Input() floatLabel: 'always' | 'auto' = 'auto';
    @Input() placeholder = '';
    @Input() selectList;
    @Input() control: UntypedFormControl;
    @Input() multiple;
    @Output() selectChange: EventEmitter<any> = new EventEmitter();
    @Input() customLabel = '';

    @ViewChild("btnRef", { static: false }) btn;
    @ViewChild("btnIconRef", { static: false }) btnIcon;
    @ViewChild("btnLabelRef", { static: false }) btnLabel;

    selected = [];
    selectedLabel = '';


    ngOnInit(): void {

        this.selected = [];
        this.selectedLabel = '';
        this.multiple = Support.numberToBoolean(this.multiple);

        if (this.multiple && this.control.value?.length) {
            _.forEach(this.selectList, (selectItem) => {
                if (selectItem.count !== 0 && this.control.value.includes(selectItem._id)) {
                    selectItem.selected = true
                    this.selected.push(selectItem.name[this.translate.currentLang]);
                };
            })
        } else if (this.control.value) {
            _.forEach(this.selectList, (selectItem) => {
                if (selectItem.count !== 0 && this.control.value.includes(selectItem._id)) {
                    selectItem.selected = true
                    this.selected = [selectItem?.name[this.translate.currentLang] || ''];
                    return false;
                };
            })

        }
        this.selectedLabel = this.selected.join(', ')

    }


    toggleSelectValue(value, item, event) {
        if (item.count === 0) return;
        if (this.multiple && !this.control.value?.length) this.control.setValue([]);
        item.selected = !item.selected;
        if (this.multiple) {
            let items = this.control.value || [];
            if (item.selected) {
                items.push(value);
                this.selected.push(item.name[this.translate.currentLang]);
                this.control.setValue(items);
            } else {
                _.remove(items, (val, index) => {
                    if (val == value) {
                        this.selected.splice(index, 1);
                        return true;
                    }
                });
                if (!items) items = [];
                this.control.setValue(items);
            }
        }
        else {
            this.selected = [item?.name[this.translate.currentLang] || ''];
            this.control.value == value ? this.control.reset() : this.control.setValue(value);
            this.isOpen = false;
        }
        event.preventDefault();
        event.stopPropagation();

        this.selectChange.emit(value);


        this.selectedLabel = this.selected.join(', ')
    }

    isOpen = false;

    menuClickOutside(event) {
        if (event.srcElement == this.btn?.nativeElement || event.srcElement == this.btnIcon?._elementRef?.nativeElement || event.srcElement == this.btnLabel?.nativeElement) {
            this.isOpen = false;
            event.preventDefault();
            event.stopPropagation();
        } else {
            let found = false;
            _.forEach(this.btnLabel?.nativeElement.children, child => {
                if (child == event.srcElement) {
                    found = true;
                    return false;
                }
            })
            this.isOpen = false;
            if (found) {
                event.preventDefault();
                event.stopPropagation();

            }

        }
    }

    toggleTrigger(evt) {
        this.isOpen = !this.isOpen;
        evt.preventDefault();
        evt.stopPropagation();
    }

    showMore(filterList?) {
        filterList.expanded = filterList.expanded === undefined ? true : !filterList.expanded;

        if (filterList.expanded) {
            filterList.classList.remove('show-more');
        } else {
            filterList.classList.add('show-more');
        }
    }
    public trackItem(index: number, item) {
        return item._id;
    }

}
